import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { useStyles } from "./confirmDialog.styles";

type Props = {
  message: string;
  bodyMessage?: string;
  isOpen: boolean;
  handleConfirmDelete: () => void;
  handleDialogClose: () => void;
  confirmDialogMessage?: string;
  customCss?: string;
};

export const ConfirmDialog = ({
  message,
  bodyMessage,
  isOpen,
  handleConfirmDelete,
  handleDialogClose,
  confirmDialogMessage,
  customCss,
}: Props) => {
  const classes = useStyles();
  return (
    <Dialog
      open={isOpen}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid="alert-dialog"
      className={customCss}
    >
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        {message}
      </DialogTitle>
      {bodyMessage && (
        <DialogContent>
          <DialogContentText
            data-testid="alert-dialog-description"
            id="alert-dialog-description"
            className={classes.bodyMessage}
          >
            {bodyMessage}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions className={classes.actions}>
        <Button onClick={handleDialogClose} className={classes.secondary}>
          Cancel
        </Button>
        <Button
          data-testid="confirm-dialog-button"
          onClick={handleConfirmDelete}
          className={classes.primary}
          variant="contained"
          autoFocus
        >
          {confirmDialogMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.defaultProps = {
  confirmDialogMessage: "Confirm",
  customCss: "",
};
